import React from 'react';
import { Gem } from 'lucide-react';

const CollectionTab = ({ ownedNfts, ownedSkins }) => (
  <div className="space-y-6">
    <div className="glass-card p-5">
      <h2 className="font-game text-sm text-[#9945FF] mb-4 flex items-center gap-2"><Gem className="w-4 h-4" /> NFT CHARACTERS ({ownedNfts.length})</h2>
      {ownedNfts.length === 0 ? (
        <p className="text-[#666] text-sm text-center py-4">No NFTs owned</p>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
          {ownedNfts.map((nft, i) => (
            <div key={i} className="bg-[#111] rounded-lg p-3 text-center border border-[#9945FF]/30">
              <Gem className="w-8 h-8 text-[#9945FF] mx-auto mb-2" />
              <p className="text-xs text-white font-game">{nft.replace('nft_', '').replace(/_/g, ' ')}</p>
            </div>
          ))}
        </div>
      )}
    </div>
    <div className="glass-card p-5">
      <h2 className="font-game text-sm text-[#14F195] mb-4">SKINS ({ownedSkins.length})</h2>
      {ownedSkins.length === 0 ? (
        <p className="text-[#666] text-sm text-center py-4">No skins owned</p>
      ) : (
        <div className="grid grid-cols-3 sm:grid-cols-6 gap-3">
          {ownedSkins.map((skin, i) => (
            <div key={i} className="bg-[#111] rounded-lg p-3 text-center border border-[#14F195]/30">
              <p className="text-[10px] text-white font-game">{skin.replace(/_/g, ' ')}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  </div>
);

export default CollectionTab;
